/**
 * Users Empty State Component
 *
 * Displayed when no users are found
 */

import React from 'react';
import { EmptyState } from '@tpct/admin-ui';
import { __ } from '@/hub-shared/utils/i18n';

type UsersEmptyStateProps = {
  onRefresh: () => void;
};

const UsersEmptyState = ({ onRefresh: _onRefresh }: UsersEmptyStateProps) => {
  return (
    <EmptyState
      title={__('Aucun utilisateur trouvé')}
      description={__('Commencez par créer votre premier utilisateur.')}
      className="users-empty-state"
    />
  );
};

export default UsersEmptyState;

